/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// TODO fix and remove eslint disables
import { docData } from 'rxfire/firestore';
import { db } from '../Firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { tap, shareReplay } from 'rxjs/operators';
import { PartialStateT, StateT } from '../shared/codecs/State';
import { decodeWithOrError } from '../rxjs/Decode';
import { switchMap, map, catchError, EMPTY } from 'rxjs';
import { authed_user } from '../Users/observables';
export const state = authed_user.pipe(switchMap((user) => {
    const state_doc = doc(db, 'organizations', user.organization, 'control', 'state');
    return docData(state_doc).pipe(tap(state => {
        console.log('got state');
    }), decodeWithOrError(StateT), catchError(err => {
        if (err instanceof Error) {
            console.error('Error thrown while decoding the state');
        }
        return EMPTY;
    }), shareReplay(1));
}), shareReplay(1));
export const set_state = authed_user.pipe(map((user) => {
    return (state) => {
        const state_doc = doc(db, 'organizations', user.organization, 'control', 'state');
        return updateDoc(state_doc, PartialStateT.encode(state));
    };
}), tap(_ => {
    console.log('New set_state');
}), shareReplay(1));
export const return_to_lobby = set_state.pipe(map((set_state) => async () => {
    await set_state({
        phase: 'lobby',
    });
}), shareReplay(1));
